import * as React from 'react';

import { cn } from '../../../lib/stylingUtils';
import { ComplexKeyboardShortcut } from '../../../types/keyboard';
import { ButtonProps } from '../buttons/Button';

const isMac = globalThis.navigator?.userAgent.includes('Macintosh');

export type KbdProps = {
  shortcut: ComplexKeyboardShortcut;
  variant?: ButtonProps['variant'];
  className?: string;
  style?: React.CSSProperties;
};

export const Kbd = ({ shortcut, variant, className, style }: KbdProps) => (
  <kbd
    style={style}
    className={cn(
      '@Kbd',
      'relative overflow-clip rounded p-[5px] font-sans text-[11px] leading-[1em] capitalize',
      variant === 'outline' &&
        'text-custom-color after:absolute after:inset-0 after:block after:bg-custom-color after:opacity-15 after:content-[""]',
      variant === 'text' &&
        'text-custom-color after:absolute after:inset-0 after:block after:bg-custom-color after:opacity-15 after:content-[""]',
      variant === undefined && 'bg-abs-white/20 text-abs-white/80',
      className,
    )}
  >
    {shortcut
      .replace(/Meta/, '⌘')
      .replace(/Alt/, isMac ? '⌥' : 'Alt')
      .replace(/Escape/, 'Esc')
      .replace(/Backspace/, '⌫')
      .replace(/ArrowLeft/, '←')
      .replace(/ArrowRight/, '→')
      .replace(/ArrowUp/, '↑')
      .replace(/ArrowDown/, '↓')}
  </kbd>
);
